import { bootAnalytics, configFromEnv } from '@reed/analytics';

// GA4 for the employer onboarding funnel (#1458). Off unless the build has a
// GTM container and a Cookiebot id; see frontend/analytics.
export function startAnalytics(): void {
  bootAnalytics(configFromEnv(import.meta.env, { requireEligibility: false }));
}

/** The longest a navigation waits for attribution and the event combined. */
export const PRE_NAVIGATION_BUDGET_MS = 2000;

/**
 * Runs best-effort work before a full-page navigation, never for longer than
 * budgetMs. The signal aborts in-flight requests when the budget runs out.
 */
export async function runBeforeNavigation(
  work: (signal: AbortSignal) => Promise<unknown>,
  budgetMs: number = PRE_NAVIGATION_BUDGET_MS,
): Promise<void> {
  const controller = new AbortController();
  let timer: ReturnType<typeof setTimeout> | undefined;

  const budget = new Promise<void>((resolve) => {
    timer = setTimeout(() => {
      controller.abort();
      resolve();
    }, budgetMs);
  });
  const done = work(controller.signal).then(
    () => undefined,
    () => undefined,
  );

  await Promise.race([done, budget]);
  clearTimeout(timer);
}
